module.exports = __webpack_public_path__ + "img/ywtdIcon.1904b512.png";